import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import enviromentVariables from 'erpcore/utils/enviromentVariables';

const HeadMeta = ({ title, description }) => {
    const getTitle = () => {
        const reactAppName = enviromentVariables?.REACT_APP_NAME || 'OTB';

        if (title) {
            return `${title} - ${reactAppName}`;
        }
        return reactAppName;
    };

    return (
        <Helmet>
            <title>{getTitle()}</title>
            <meta name="description" content={description} />
        </Helmet>
    );
};

HeadMeta.defaultProps = {
    title: null,
    description: 'Description'
};

HeadMeta.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string
};

export default HeadMeta;
